import { axiosInstance } from '@/lib/axios'

export interface CompanyDatabaseModel {
  id: number
  databaseId: number
  databaseName: string
  serverId: number
  label: string | null
  isActive: boolean
  isStarter: boolean
  status: string | null
  currentVersion: string | null
  isCompatibleWithModel: boolean | null
  migrationFailed?: boolean
  createdDate: string
}

export interface DuplicateDatabaseForCompanyRequest {
  companyId: string
  newDatabaseName?: string
  label?: string
}

export interface AddDatabaseToCompanyRequest {
  companyId: string
  serverId: number
  databaseName?: string
  label?: string
}

export interface SetActiveDatabaseRequest {
  companyId: string
  databaseId: number
}

export interface RemoveDatabaseFromCompanyRequest {
  companyId: string
  databaseId: number
}

export function listCompanyDatabases(companyId: string) {
  return axiosInstance.get<CompanyDatabaseModel[]>(
    `/config-api/companydatabase/list?companyId=${companyId}`,
  )
}

export function duplicateDatabaseForCompany(
  request: DuplicateDatabaseForCompanyRequest,
) {
  return axiosInstance.post('/config-api/companydatabase/duplicate', request)
}

export function addDatabaseToCompany(request: AddDatabaseToCompanyRequest) {
  return axiosInstance.post('/config-api/companydatabase/add', request)
}

export function setActiveDatabase(request: SetActiveDatabaseRequest) {
  return axiosInstance.post('/config-api/companydatabase/setActive', request)
}

export function removeDatabaseFromCompany(
  request: RemoveDatabaseFromCompanyRequest,
) {
  return axiosInstance.post('/config-api/companydatabase/remove', request)
}

export interface MoveDatabaseToCompanyRequest {
  sourceCompanyId: string
  databaseId: number
  destinationCompanyId: string
}

export function moveDatabaseToCompany(request: MoveDatabaseToCompanyRequest) {
  return axiosInstance.post('/config-api/companydatabase/move', request)
}

export interface UpdateDatabaseLabelRequest {
  companyId: string
  databaseId: number
  label: string
}

export function updateDatabaseLabel(request: UpdateDatabaseLabelRequest) {
  return axiosInstance.post('/config-api/companydatabase/updateLabel', request)
}
